module.exports = __webpack_public_path__ + "static/media/travel-armenia.a6b9bb11.jpg";